import cn from 'classnames';
import { FC, PointerEvent } from 'react';

import styles from './ColumnResizeHandle.module.scss';

type ColumnResizeHandleProps = {
  className?: string;
  dataComponent?: string;
  onPointerDown: (event: PointerEvent<HTMLSpanElement>) => void;
};

export const ColumnResizeHandle: FC<ColumnResizeHandleProps> = (props) => {
  const { className, dataComponent, onPointerDown } = props;

  return (
    <span
      aria-hidden
      data-component={dataComponent}
      className={cn(styles.handle, className)}
      onPointerDown={onPointerDown}
    />
  );
};
